export default __webpack_public_path__ + "static/media/Icon-AI-Scanner-Close.e0624a47.svg";